export class StateMode {
    protected _domItems: HTMLDivElement[] = [];
    private _active: boolean = false;
    private _id: StateModeIdentifier;
    private _callbackList: (() => void)[] = [];

    constructor(id: StateModeIdentifier) {
        this._id = id;
    }

    appendDomItem(d: HTMLDivElement) {
        this._domItems.push(d);
    }

    get id(): StateModeIdentifier {
        return this._id;
    }

    get active(): boolean {
        return this._active;
    }
    set active(v: boolean) {
        this._active = v;
        if (this._active) {
            this._callbackList.forEach(c => {
                c();
            });
        }
        this._domRefreshDisplay();
    }


    protected _domRefreshDisplay() {
        this._domItems.forEach(d => {
            if (this._active) {
                d.style.display = 'block';
            }
            // d.style.display = (this._active) ? 'block' : 'none'; 
        });
    }

    attachAction(callback: (() => void)) {
        this._callbackList.push(callback);
        return this;
    }



}


export type StateModeIdentifier = 'default' | 'select-rectangle' | 'select-polygon' | 'select-file' | 'file-selected';
